/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_Tool_3Inputs */

const en_mk_tb_example_tool_3 = /** @type {(inputs: Mk_Tb_Example_Tool_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product decision needed before the next task`)
};

const id_mk_tb_example_tool_3 = /** @type {(inputs: Mk_Tb_Example_Tool_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keputusan produk dibutuhkan sebelum tugas berikutnya`)
};

/**
* | output |
* | --- |
* | "Product decision needed before the next task" |
*
* @param {Mk_Tb_Example_Tool_3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_tool_3 = /** @type {((inputs?: Mk_Tb_Example_Tool_3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_Tool_3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_tool_3(inputs)
	return en_mk_tb_example_tool_3(inputs)
});